import React from 'react'
import { Card } from 'react-bootstrap'

export default function IntakeEmpty() {
  return (
    <Card style={{ border: '0px' }}>
      <Card.Body>
        <h5 className='font-weight-bold'>
          There are no Intakes to display.
        </h5>
        <div className='my-4'>
          When you have Intakes they will appear here.
        </div>
      </Card.Body>
    </Card>
  )
}
